module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("M")])]), _vm._v("iranda Warfield, the Duchess of Windmere, stood silently while her maid opened her dressing room door. Allowing a final smoothing of fabric and tucking of loosened strands of hair by her maid, she hesitated for a moment. Then, setting her feet on the well-worn path down the hall, she began the walk that would lead from His Grace’s room down to the dining room for a late supper.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Each of her days was filled with just such repetitive behavior. Rising from sleep, eating meals, dressing for engagements and going to sleep again all fit neatly into a narrowly defined schedule for the Duchess of Windmere. Pausing in front of her husband’s door, she realized that since today was Thursday, the night would end with Windmere’s weekly visit to her bed. And on the morrow, when faced with the dowager duchess’s thinly disguised question about the condition of her ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("health, at their ritual Friday morning breakfast, Miranda could smile demurely and simply nod, saying without words that she was doing her duty to the duke in all facets of their life.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She arrived at the duke’s door and waited for his valet to open it. The slight pause expanded to several seconds and then to nearly a full minute. Startled by this change, she cocked her head and listened for any activity within. It was a regrettable habit from her past, but one that was useful at times. Loud whispers and scuffling feet were evident, but she did not hear His Grace’s deep voice. She had just decided to knock when Fisk rushed to her side.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Allow me, Your Grace,” her efficient maid said, stepping around her and knocking on the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Miranda was reminded once more that she had servants to do her bidding and that something as innocuous as knocking on a door was beneath her now. Standing quietly as they awaited a response, she thought on how strange this was. It was at times like this that she longed to be the squire’s daughter once more, with little or none of the pretense needed to live this life. Shaking her head, she banished the thoughts before they could take hold.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The door swung open and, instead of Windmere, Thompson the valet stepped forward. This, too, was very strange.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your Grace,” he said as he bowed deeply to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thompson.”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“His Grace will be unavailable to join you for dinner, but he bids you to enjoy your outings this evening.” The strain in his voice told her that this was not usual. She swore his left eye was twitching as he spoke. Another sign of this upheaval in the normal decorum?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The two servants turned to her, obviously awaiting her reaction. Before she could speak, a loud crash and a string of rather earthy curses came from Windmere’s bedchamber. Thompson coughed loudly, an obvious yet unsuccessful attempt to disguise the words not meant for a lady’s ears. It was definitely Windmere’s voice, but she had not heard it raised in anger, as it was now, for many years.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your pardon, Your Grace. His Grace is indisposed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Decorum is more important than anything else in a duke or duchess’s life.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The dowager’s words rang in her thoughts, and Miranda knew what was expected of her. She nodded to Thompson and turned from the door. Walking down the hall and then down the stairs to the dining room, she was pleased that no one who watched her would be able to see the turmoil filling her thoughts as she contemplated her husband’s remarkable condition.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("She sat in the chair, held out by the butler, and realized that the last time she’d heard Windmere yelling in anger was before he’d ascended to the title, when he was still Adrian and she was only slightly less suitable for him as a second son. Since he’d become the duke, he never raised his voice to her or expressed anything other ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("than polite enthusiasm during conversations or engagements. This was extraordinary.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The first dish was placed before her and she took no notice of what it was. How could she when something so different had drawn her attention? Sherman repeated its ingredients, but it could have been dirt laced with arsenic for all she heard. Slicing into it and lifting the fork to her mouth, Miranda finally realized what the true surprise was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her husband, the Duke of Windmere, was drunk.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The food in her mouth turned to dust as she took in this insight. He had never, not in all the years she’d known him, before or after their marriage, before or since accepting the title, been drunk in her presence or within her hearing. But he was now. Miranda took a sip of the wine in her goblet to ease the food’s way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is something wrong with the scallops, Your Grace?” Sherman leaned in closer to whisper the question to her. It would be unseemly if she were to complain too loudly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is fine, Sherman. Please continue with the next course.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Drifting back to her thoughts over the duke’s condition, she knew that he was extremely angry about something, angry enough to drink to excess. So angry that he was purposely breaking items in his chamber. What could have him so upset?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It is inappropriate and unacceptable for a wife to inquire about or to meddle in the affairs of her husband or his interests.")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Miranda blinked as she heard once more the dowager’s voice issuing another warning about her behavior. The words were as clear as if the woman sat at table with her. Miranda sat up straighter and tried to focus on the food being placed before her; that was surely something appropriate for her attention.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the surprising behavior of the duke had rattled her. Not that he was drunk, for she knew men drank and sometimes drank to excess. Not that he was angry, although it was out of character with His Grace’s deportment of the last several years.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, what rattled her and made her thoughts drift into inappropriate directions was that, for the first time in such a very long time, their lives were not following the ritual and regimented schedule that had been established. For the first time, she had been surprised and a bit shocked, something that had not happened between her and her husband in too many years. For the first time in too long, the duke showed himself to be a simple man with faults and weaknesses.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Miranda shivered with a completely inappropriate measure of anticipation that there might be a real person existing within the shell of the duke. For one moment, she let herself remember the promising beginning to their marriage and to wish for a real life instead of this sham and ritual and politeness. Although she regretted whatever it was that caused the duke such upset, part of her was extremely pleased. There was life in Adrian, after all.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The morning dawned bright and clear, and the aroma of chocolate awakened her from her sleep. Sliding up in bed, she leaned against the cushions a maid arranged behind her, and watched as the morning tray of chocolate and toast was placed over her lap. Taking a sip of the thick, hot beverage, Miranda realized she still wore her dressing gown over her night rail.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her husband had missed their weekly appointment!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In spite of his absence at dinner, she’d thought he would visit as usual, and so she’d gone to bed as she did every Thursday evening—in her night rail with her dressing gown on. Adrian would put out the bedside candle, slip under the covers, slide the gown from her shoulders and go about his business. When he’d left, she would go to her dressing room, wash, leave the gown at the foot of the bed and fall to sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shaking her head, she realized he’d not visited for the first time in months, years perhaps.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your Grace?” the maid whispered, curtsying as she approached the bedside. “Is something wrong with your chocolate? Should I bring you another cup?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, Betsy,” she replied, shaking her head on purpose this time. “Is His Grace…still…?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Indisposed, Your Grace?” The young maid added the correct polite term for her husband’s condition last evening.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("“Indisposed. Or has he left for his morning ride?” ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("Miranda shifted on the bed as she asked, and placed the porcelain cup back on the tray. “The weather certainly looks favorable for a ride in the park.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Did the maid comprehend her curiosity? Miranda tried to keep just the right tone of disinterest in her voice, but feared her underlying questions were being betrayed…to a maid.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before Betsy could answer her questions, the door opened and Fisk stepped in. With a look at her first, her competent lady’s maid dismissed the young girl with a nod and waited for Betsy to leave before speaking.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“His Grace is still abed and did not leave the house last night after he missed dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How very strange.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The words slipped out before she could stop them, but if Fisk thought them unusual or unseemly, she did not, would not, say so. It was amazing that the change in the duke’s behavior for one evening could throw the whole household into disarray so easily.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Motioning that she was finished with the half-eaten toast and chocolate, Miranda waited for it to be removed and then slid from her bed. Walking into her dressing room, she found her clothes laid out and ready for her. Fisk stepped into the room and, with her usual efficiency, soon had Miranda dressed, with her hair arranged, and ready to face her weekly interview by the duke’s mother.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("As the door to her chambers was opened for her, Miranda realized she would never be ready to face this particular ritual in the Warfield family. At least not until she ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("could bring the news that she carried Windmere’s heir. And with each passing month and year, that declaration seemed more and more unlikely.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The drive to the dowager’s residence a few blocks away did not take long enough for her to banish completely the questions that pushed forward into her thoughts. As she entered the drawing room and took a seat on the couch nearest the windows overlooking the gardens, she breathed deeply, trying to regain a sense of calm, a sense of her true self, before she was confronted by her dragonlike mother-by-marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Miranda.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the very sound of the commanding voice, Miranda stood and nodded. One did not remain seated when Cordelia Masters Warfield, dowager Duchess of Windmere, entered a room. No matter whose precedence was higher. No matter the age of those waiting or their position in society. Everyone stood when Her Grace entered. Miranda had it on good authority that even the Regent himself reacted so in the dowager’s presence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a posture and gait that any governess or tutor in the womanly arts would be proud of, the older woman crossed the expansive room to the large chair across from where Miranda had chosen to sit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On another woman, the soft white of her hair and the clear blue gaze would have been inviting and warm. On the dowager, however, it only accented the harsh lines of dissatisfaction around her mouth and the coldness of that gaze.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lowering herself to the seat, Cordelia placed herself exactly six inches from the back of the chair and laid her hands on her lap. Miranda knew it was six inches because Cordelia always reminded her of the correct posture and bearing needed by a duchess, whether in public or private.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Attempting to follow her example, Miranda sank to the couch, straightened her spine and crossed her own hands in her lap. When the dowager simply cleared her throat instead of coughing discreetly, Miranda knew she had attained the desired position. The cough was a signal to the butler to bring in the tea.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Arriving too late for a country breakfast and too early for a city one, Miranda knew not to expect more than the tea and biscuits placed before her. Cordelia hated city hours and was up at dawn, complaining liberally of the lack of fortitude in others who needed to sleep away most of their mornings. Having lived with this woman prior to her husband attaining his title, Miranda knew exactly what to expect. The dowager simply wanted a report, and then Miranda would be dismissed with as little regard as the servants were. Any pretenses of warmth and caring had dissipated as the hoped-for heir never appeared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How are you this morning, Miranda?” Although the dowager stirred her tea, her gaze never left Miranda’s face. She was looking for signs…of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("delicate condition.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am well, Your Grace. And you?” Miranda looked away, giving the answer without the words. Still barren. When she turned back, the grimace still tightened the older woman’s face.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My goddaughter will be attending Lady Crispin’s ball next week. Do you plan on attending as well?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The subject changed neatly from a distressingly personal one to an unremarkable social one, without so much as a moment’s hesitation and without any acknowledgment of the woman’s continued disappointment. Miranda simply nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And my son?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your Grace, I would not presume to know Windmere’s schedule.” Cordelia’s eyes narrowed as she looked for some sign of disrespect in her words. Miranda met her intense gaze with a guileless one. “I could ask His Grace’s secretary if you wish me to?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Miranda had aided Cordelia’s attempts to launch her goddaughter in society, and she would continue to do so. She would not hold her own anger and frustration at the dowager against an innocent girl.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I will send word to his secretary,” Cordelia announced, standing and smoothing the elaborate morning gown as she did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“About what, Mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Miranda gave a start at the sound of her husband’s voice. Turning slowly in her seat, she watched as Adrian walked into the drawing room and greeted his mother and her with a civilized nod. One look at his gait and the way he held his head told her that he was suffering the lingering effects of his condition the evening before.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("“I would appreciate your presence at the Crispins’ ball next week. It will only be Juliet’s third one since ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("her presentation to the queen and, as family, it is appropriate for us to attend with her.” The dowager paused and passed her sharp gaze over her son.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you well, Windmere?” She asked her question, but assessed her son even as she spoke. “You look rather washed out and peaked.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Miranda examined Adrian’s appearance as well. His linen, like the rest of his garments, was immaculate as usual, and he was done up in the latest fashion. He’d recently had his longish hair clipped in a shorter style and it revealed the natural body of it as the black locks curled just above his collar. He still cut a dashing figure, as he had when they’d met, so long ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was not his clothing that gave away his condition as much as the sallowness of his normally tanned complexion and the red streaks in the whites of his eyes. He looked every inch the man suffering from the aftermath of too much alcohol.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am fine, Mother. Just tired,” he said. Meeting Miranda’s gaze, he seemed to be waiting for her to reveal the truth. When she simply nodded, he continued, “I am not certain of my plans over these next few weeks. I must go to Windmere Park to deal with some…business, and I do not know when I will return.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("He saw his wife’s eyes narrow at his hesitation and waited for Miranda’s questions. They did not come. But of course not. Miranda had been trained as the perfect lady by his mother, and would never question him in ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("public. And since being under the dowager’s tutelage, she did not question him in private, either.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How would she react to the news of her impending widowhood? Would she react at all? Now was not the time to present such information. First, Adrian knew, he must sort through the practicalities and legalities of what his death would cause, and then he would speak to her about it. Or mayhap the physicians had the right of it—better not to know too far ahead of such a dire circumstance?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When Parliament is in session? I thought you were keen on speaking to some of the issues,” his mother said. He could see that she definitely wanted to press him on this, but her unwavering control over something as trite as curiosity did not wane.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With her steely gaze on him, he tried to organize his thoughts in spite of the pounding in his head, the churning of his stomach and the stinging in his eyes. Dragging a hand through his hair, he took a deep breath before answering.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There are estate concerns which I must resolve, Mother. I will miss only a few sessions while protecting our family’s interests in the north.” He played the trump card in his hand—family matters—ruthlessly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then, to his horror, a cough welled up deep inside his lungs. Walking to the door that opened to the gardens, and trying to appear nonchalant, he lifted his hand to his mouth to cover the worst of it. For once, Providence heard his plea and no more followed the first.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Would you like me to accompany you?” Miranda’s soft voice drew his attention, but he kept his back turned. “I have no pressing engagements here in town.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Had she any idea of how brandy-faced he’d been last evening? He remembered cursing his fate in rather loud and vulgar language…had she heard? With so many uncertainties ahead of him, Adrian decided he should make this trip alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There is no reason for you to give up the Season at its height for the dull country, my dear. I shan’t be away for more than a week at the most.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He faced her now and noticed the brightness of her blue eyes and the fullness of her lips as her mouth formed a moue, as though she was disappointed in his decision to go alone. Any reply she would have made was interrupted when his mother coughed lightly and stared at Miranda. Some unspoken communication was shared in that moment by the two women, and he watched as Miranda sat up straighter, if that were possible, and closed her mouth, her lips now forming a tight line.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("A memory flashed through his mind and he saw Miranda at their first meeting. The only daughter of one of their neighbors, a wealthy landowner with a minor title, she had been invited to a country dance at his family’s estate. Drawn by her vivacious personality and her welcoming smile, he had asked her to dance. He could still see her dark blond curls, hanging down to her shoulders, shimmering and gleaming in the candlelight as they’d ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("danced. She’d been generous in gifting him with her smiles, and they had laughed through the steps of the dance, then gone in to supper together.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her standing, with the sizable portion she would bring to him in their marriage settlement, was deemed high enough for his status as the second son of a duke, and their marriage was accomplished the next year, even before his brother and the heir of the family married. Shrugging off the past that could not be changed, Adrian realized that he was staring at her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Uncomfortable with what haunted him from his past and what faced him in the near future, Adrian nodded at his mother first and then his wife. “I fear I have much to accomplish before I can be on my way.” Retreating into good manners, he bowed to them and walked to the door, which was opened for him by a footman. “Good day to you both,” he said as he left, feeling for the first time a certain trepidation at leaving Miranda in the clutches of the dowager.")])])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page30"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82f39ffe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426878497_ch02.vue
// module id = 81
// module chunks = 0